/* eslint-disable */
import { remainingTokenTime } from "@/helpers";

import authAPI from "./data";

const state = {
  access: "",
  refresh: "",
  error: "",
  user: {},
  initializing: true
};

// getters
const getters = {
  authenticated: state => {
    return !!state.access;
  },
  headers: state => {
    return {
      authorization: `Bearer ${state.access}`
    }
  }
};

// actions
const actions = {
  initAuth: (context, retryCount = 0) => {
    const refreshToken = authAPI.refreshToken.get();
    if (!!refreshToken) {
      context.commit("SET_REFRESH_TOKEN", refreshToken);
      return authAPI.requestAccessToken(context.state.refresh).then(data => {
        context.commit("SET_ACCESS_TOKEN", data.access);
        context.commit("INIT_COMPLETE");
        context.dispatch("refreshAccessToken");
      }).catch(error => {
        if (retryCount < 5) {
          return context.dispatch("initAuth", retryCount + 1);
        } else {
          context.dispatch("logout");
          context.commit("INIT_COMPLETE");
        }
      });
    } else {
      context.dispatch("logout");
      context.commit("INIT_COMPLETE");
    }
  },
  refreshAccessToken: context => {
    const expiration = authAPI.tokenExpirationInMilliseconds(
      context.state.access
    );
    const timeout = Math.max(expiration - 1000 * 30, 0);
    setTimeout(() => {
      authAPI
        .requestAccessToken(context.state.refresh)
        .then(data => {
          context.commit("SET_ACCESS_TOKEN", data.access);
          context.dispatch("refreshAccessToken");
        })
        .catch(error => {
          context.dispatch("logout");
        });
    }, timeout);
  },
  login: (context, { username, password }) => {
    return authAPI
      .requestTokens(username, password)
      .then(data => {
        if (!!data.access && !!data.refresh) {
          context.commit("SET_ACCESS_TOKEN", data.access);
          context.commit("SET_REFRESH_TOKEN", data.refresh);
          authAPI.refreshToken.set(data.refresh);
          context.dispatch("refreshAccessToken");
        } else {
          throw "Invalid Server Response";
        }
      })
      .catch(error => {
        context.commit("SET_ERROR", error);
      });
  },
  logout({ commit }) {
    commit("LOGOUT");
    authAPI.refreshToken.remove();
  }
};

// mutations
const mutations = {
  INIT_COMPLETE(state) {
    state.initializing = false;
  },
  SET_ACCESS_TOKEN(state, access) {
    state.access = access;
  },
  SET_REFRESH_TOKEN(state, refresh) {
    state.refresh = refresh;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  LOGOUT(state) {
    state.access = "";
    state.refresh = "";
    state.error = "";
    state.user = {};
    localStorage.clear();
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
